import {
    isDateInRange,
    TimeEntryType,
    type DateRange,
    type Employee,
    type RosterTab,
    type TimeEntry,
} from "@pentacode/core";

const clearableTypes = new Set([TimeEntryType.Work, TimeEntryType.CompDay, TimeEntryType.Free]);
export const filterClearableEntries = (
    entries: TimeEntry[],
    employees: Employee[],
    departments: number[],
    activeTab: Pick<RosterTab, "time" | "types"> | undefined,
    dateRange: DateRange,
    hasAccess: (entry: TimeEntry) => boolean,
    options: {
        includePlanned?: boolean;
        includeFinished?: boolean;
    }
) => {
    const time = activeTab?.time;
    const types = activeTab?.types;

    const employeeMap = new Map(employees.map((emp) => [emp.id, emp.positions]));
    const employeeInDepartment = (employeeId: number) => {
        const positions = employeeMap.get(employeeId);
        if (!positions) return false;

        return positions.some((p) => departments.includes(p.departmentId));
    };

    const tabTypes = types && new Set([TimeEntryType.Work, ...types]);
    return entries.filter((entry) => {
        if (entry.deleted) return false;
        if (!isDateInRange(entry.date, dateRange)) return false;
        if (!hasAccess(entry)) return false;
        if (!clearableTypes.has(entry.type)) return false;

        // filter by types if specified
        if (tabTypes && !tabTypes.has(entry.type)) return false;

        // filter by departments
        if (entry.position && !departments.includes(entry.position.departmentId)) return false;
        // check if employee belongs to one of the specified departments
        if (!entry.position && entry.employeeId && !employeeInDepartment(entry.employeeId)) return false;

        if (time && !entry.matchesTimeFilter(time)) return false;

        // exclude planned if not specified
        if (!options.includePlanned && entry.type === TimeEntryType.Work && !entry.startFinal) return false;
        // exclude finished if not specified
        if (!options.includeFinished && entry.type === TimeEntryType.Work && entry.startFinal) return false;

        return true;
    });
};
